























































































































import { Component, Prop, Watch } from "vue-property-decorator";
import GiganautVueDialog from "@/components/Shared/GiganautVueDialog";
import { BookingDetailsModule } from "@/store/modules/bookingDetails";
import BookingDto from "@/models/Bookings/BookingDto";
import { AgencySettingsModule } from "@/store/modules/agencySettings";

@Component({
  name: "BookingGeneralDetailsEdit",
})
export default class extends GiganautVueDialog {
  public dialog = false;
  public entity = new BookingDto();

  @Watch("dialog")
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      //await BookingDetailsModule.getNewBookingOptions();
      this.entity = JSON.parse(
        JSON.stringify(BookingDetailsModule.currentBooking)
      );
      if (AgencySettingsModule.branches.length === 0) {
        await AgencySettingsModule.getBranches();
      }
      if (AgencySettingsModule.agencyUsers.length === 0) {
        await AgencySettingsModule.getAgencyUsers();
      }
    }
  }

  get agencyUsers() {
    return AgencySettingsModule.agencyUsers;
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    BookingDetailsModule.editBookingGeneralDetails(this.entity);
    this.dialog = false;
  }
}
